import {
    Box,
    Divider,
    IconButton,
    Paper,
    Stack,
    Typography
} from "@mui/material";
import React from "react";
import { allIcons } from "../../assets";

export const CustomContainer = ({
    paperProps,
    headerProps,
    childrenProps,
    children,
    primaryHeading,
    secondaryHeading,
    onBackButton,
    customHeaderIcon,
    customHeaderActions,
    filterSection,
}) => {

    // Render Back Button
    const renderBackButton = () => {
        return (
            <IconButton
                onClick={onBackButton}
                disableRipple
                sx={{ padding: 0, "&:hover": { backgroundColor: "transparent" } }}
            >
                <img src={allIcons.backIcon} alt={"card-icon"} width={25} height={25} />
            </IconButton>
        );
    };

    // Render Default Icon
    const renderDefaultIcon = () => {
        return (
            <img src={allIcons.cardIcon} alt={"back-icon"} width={40} height={40} />
        );
    };

    // Render Header Icon
    const renderHeaderIcon = () => {
        return (
            customHeaderIcon
        );
    };

    // Render Primary Heading
    const renderHeaderHeadings = () => {
        return (
            <Box>
                <Typography
                    variant={"body1"}
                    fontWeight={600}
                    lineHeight={"normal"}
                    textTransform={"capitalize"}
                >
                    {primaryHeading}
                </Typography>
                <Typography
                    variant={"body2"}
                    color={"text.secondary"}
                >
                    {secondaryHeading}
                </Typography>
            </Box>
        );
    };

    return (

        <Paper sx={{ borderRadius: "6px" }} {...paperProps}>
            {/* Header Section */}
            <Stack
                p={2}
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems={{ sm: "center" }}
                gap={{ xs: 1.5, sm: 0 }}
                {...headerProps}
            >
                <Stack gap={2} direction={"row"} alignItems={"center"} flex={1}>
                    {onBackButton ? renderBackButton() : customHeaderIcon ? renderHeaderIcon() : renderDefaultIcon()}
                    {renderHeaderHeadings()}
                </Stack>
                {customHeaderActions && customHeaderActions}
            </Stack>
            {/* Divider */}
            <Divider />
            {/* Filter Section */}
            {filterSection && filterSection}
            {/* Children Section */}
            <Box p={"12px 16px"} {...childrenProps}>
                {children}
            </Box>
        </Paper>
    );
};

